import { Popper } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import {
  PLAN_TYPE_NAMES,
  COLLECTIONS_PLAN_TYPE,
  NON_DELIVERY_PLAN_TYPES,
} from "../../consts/planTypes";

import { getParcels } from "../../utils/routes";

import { View } from "../View";

const useStyles = makeStyles(() => ({
  popper: {
    display: "flex",
    flexDirection: "column",
    gap: "1.25rem",
    padding: "12px 15px 12px 15px",
    borderRadius: "5px",
    backgroundColor: "white",
    boxShadow: `rgba(0, 0, 0, .3) 2px 4px`,
  },
  container: {
    display: "flex",
    marginTop: "8px",
  },
  title: {
    fontWeight: "bold",
  },
  left: {
    fontWeight: "bold",
  },
  right: {
    marginLeft: "5px",
  },
}));

const volumeTypes = NON_DELIVERY_PLAN_TYPES.filter(
  (planType) => planType !== COLLECTIONS_PLAN_TYPE
);

const VolumePopup = ({ route, type, open, anchorEl }) => {
  const styles = useStyles();
  const volumesByType = volumeTypes.reduce((acc, planType) => {
    const stops = (route.stops || []).filter(
      ({ stopType }) => stopType === planType
    );
    acc[planType] = {
      stops: `${stops.length}`,
      parcels: `${getParcels({ stops })}`,
    };
    return acc;
  }, {});

  return (
    <Popper
      className={styles.popper}
      open={open}
      anchorEl={anchorEl}
      placement={"left"}
    >
      {volumeTypes
        .filter((planType) => type !== planType)
        .map((planType) => (
          <View key={planType}>
            <View className={styles.title}>
              {`${PLAN_TYPE_NAMES[planType]} Volume`}
            </View>
            <View className={styles.container}>
              <View className={styles.left}>Stops:</View>
              <View className={styles.right}>
                {volumesByType[planType].stops}
              </View>
            </View>
            <View className={styles.container}>
              <View className={styles.left}>Parcels:</View>
              <View className={styles.right}>
                {volumesByType[planType].parcels}
              </View>
            </View>
          </View>
        ))}
    </Popper>
  );
};

export default VolumePopup;
